(function(angular) {
    angular.module('bizPartEngage').directive('bizDefaultLevelProgress', bizDefaultLevelProgressDirective);

    bizDefaultLevelProgressDirective.$inject = ["bizCore"];

    function bizDefaultLevelProgressDirective(bizCoreProvider) {
        var directive = {
            restrict: "E",
            scope: true,
            templateUrl: function (element, attrs) {
            	if (!attrs.templateUrl)
            		return bizCoreProvider.getView('core.directives.defaultlevelprogress', "FrontEnd/Core/Directives/Views/DefaultLevelProgress.html");
				
            	return siteRootPath + attrs.templateUrl;
            },
            controller: bizDefaultLevelProgressController,
            controllerAs: "vm"
        };

        bizDefaultLevelProgressController.$inject = ["$rootScope", "core.users.service"];

        function bizDefaultLevelProgressController($rootScope, userService) {
            var vm = this;
            vm.CurrentLevel;
            vm.NextLevel;
            vm.UserExperienceSum = 0;
            vm.PercentageCompleted = 0;
            vm.ExpLeftToNextLevel = 0;

            vm.GetLoggedInUserDefaultLevelProgress = GetLoggedInUserDefaultLevelProgress;
            vm.CalculateExperience = CalculateExperience;

            function GetLoggedInUserDefaultLevelProgress() {
                userService.GetLoggedInUserDefaultLevelProgress().then(GetLoggedInUserDefaultLevelProgressSuccess);

                function GetLoggedInUserDefaultLevelProgressSuccess(response) {
                    vm.CurrentLevel = response.data.m_Item1;
                    vm.AllLevels = response.data.m_Item2;
                    vm.UserExperienceSum = response.data.m_Item3;

                    vm.CurrentLevelIndex = vm.AllLevels.GetIndexByValue('Id', vm.CurrentLevel.Id);

                    for (var i = 0; i < vm.AllLevels.length; i++) {
                    	if (vm.AllLevels[i].RequiredExp > vm.CurrentLevel.RequiredExp) {
                    		vm.NextLevel = vm.AllLevels[i];
                    		break;
                    	}
                    }

                    vm.CalculateExperience();
                }
            }

            function CalculateExperience() {
                var sum = vm.UserExperienceSum - vm.CurrentLevel.RequiredExp;
                var needed = vm.NextLevel !== undefined ? vm.NextLevel.RequiredExp - vm.CurrentLevel.RequiredExp : 0;

                if(~~needed > 0) {
                    vm.PercentageCompleted = (sum / needed) * 100;
                }
                else {
                    vm.PercentageCompleted = 100;
                }

                vm.ExpLeftToNextLevel = needed > 0 ? needed - sum : 0;

                if (vm.PercentageCompleted > 100)
                	vm.PercentageCompleted = 100;

                if(vm.ExpLeftToNextLevel < 0) {
                    vm.ExpLeftToNextLevel = 0;
                }
            }

            if (IsPortalSettingTrue('IsLevelSystemEnabled'))
                vm.GetLoggedInUserDefaultLevelProgress();
        }

        return directive;
    }
})(window.angular);
